module.exports = __webpack_public_path__ + "assets/img/101200.64c18c32.svg";